import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Shown when a trialing org hits the daily assessment cap (10 completions per
 * rolling 24h). Presentational — controlled by `show` / `onClose`. `info` is
 * the 402 response body: { daily_limit, next_available_at }.
 */
export default function TrialDailyLimitModal({ show, onClose, info }) {
  const navigate = useNavigate();

  // Lock body scroll while open
  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [show]);

  if (!show) return null;

  const dailyLimit = Number(info?.daily_limit) || 10;
  const nextAvailableAt = info?.next_available_at ? new Date(info.next_available_at) : null;
  const nextAvailableLabel = nextAvailableAt && !isNaN(nextAvailableAt.getTime())
    ? nextAvailableAt.toLocaleString([], { weekday: 'long', hour: 'numeric', minute: '2-digit' })
    : null;

  const handleUpgrade = () => {
    onClose && onClose();
    navigate('/billing');
  };

  return (
    <>
      <div
        className="modal fade show"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
        style={{ display: 'block' }}
        onClick={onClose}
      >
        <div
          className="modal-dialog modal-dialog-centered"
          role="document"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-content" style={{ borderRadius: '16px', border: 'none' }}>
            <div className="modal-header border-0 pb-0">
              <h5 className="modal-title fw-bold">You've hit today's assessment limit</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <p className="mb-2">
                Free trial accounts can complete {dailyLimit} assessments per day.
                Your work is saved — this assessment just can't be finalised yet.
              </p>
              <p className="mb-0 text-muted">
                {nextAvailableLabel
                  ? <>You can complete your next assessment after <strong>{nextAvailableLabel}</strong>, or upgrade now for your full plan allowance with no daily cap.</>
                  : <>Come back tomorrow, or upgrade now for your full plan allowance with no daily cap.</>}
              </p>
            </div>
            <div className="modal-footer border-0 pt-0">
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={onClose}
              >
                Come back tomorrow
              </button>
              <button
                type="button"
                className="btn btn-dark"
                onClick={handleUpgrade}
              >
                Upgrade to keep going
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" />
    </>
  );
}
